import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { Color, TypographyVariant } from 'Core-utils/types';
import { Placement } from 'react-bootstrap/esm/types';
import classNames from 'classnames';
import './styles.scss';

interface TooltipProps {
    children: React.ReactNode;
    id?: string;
    label: React.ReactNode;
    labelColor?: Color;
    labelVariant?: TypographyVariant;
    overlayContainerClassName?: string;
    overlayPlacement?: Placement;
    tooltipClassName?: string;
    /** Renders the overlay initially visible (useful for Storybook or temporary layout debugging). */
    defaultShow?: boolean;
}
const CustomTooltip = ({
    id = 'tooltip',
    label,
    labelColor,
    labelVariant,
    overlayContainerClassName,
    overlayPlacement,
    children,
    tooltipClassName,
    defaultShow,
}: TooltipProps) => {
    const tooltip = (
        <Tooltip
            id={id}
            className={classNames(
                'custom-tooltip text-text-black d-flex justify-content-center align-items-center',
                tooltipClassName,
            )}
        >
            <Typography
                variant={labelVariant ?? 'overline2'}
                color={labelColor ?? 'text-black'}
                className="d-flex justify-content-center align-items-center custom-tooltip__label-container"
            >
                <span className="custom-tooltip__label-text">{label}</span>
            </Typography>
        </Tooltip>
    );

    return (
        <OverlayTrigger
            defaultShow={defaultShow}
            placement={overlayPlacement ?? 'top'}
            overlay={tooltip}
        >
            <div
                className={
                    overlayContainerClassName ??
                    'custom-tooltip__content d-flex justify-content-center align-items-center'
                }
            >
                {children}
            </div>
        </OverlayTrigger>
    );
};

export default CustomTooltip;
